module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/node_modules/stream-browserify/node_modules/readable-stream/transform.js
// module id = ../../../../stream-browserify/node_modules/readable-stream/transform.js
// module chunks = vendor